
import { Vue, Component, Watch } from "vue-property-decorator";
import PanelHeader from "@/components/Reusable/Util/PanelHeader.vue";
import SnapshotItem from "./SnapshotItem.vue";
import { snapshotStore } from "@/store/store-accessor";
import { breakdanceUndo } from "@/lib/undo/undo";
import { closeUiPanel } from "@/lib/panels/panels";

@Component({
  components: {
    PanelHeader,
    SnapshotItem
  }
})
export default class History extends Vue {
  onSnapshotSelected(snapshotIndex: number) {
    snapshotStore.setCurrentSnapshotIndex(snapshotIndex);
    breakdanceUndo.setStoreFromCurrentSnapshot();
  }

  close() {
    closeUiPanel("history");
  }

  get snapshots() {
    return [...snapshotStore.snapshots].reverse();
  }

  get currentIndex() {
    return snapshotStore.index;
  }

  @Watch("currentIndex", { immediate: true })
  handleCurrentIndexChange() {
    this.scrollToActiveSnapshotElement();
  }

  scrollToActiveSnapshotElement() {
    Vue.nextTick(() => {
      const activeSnapshotItemDomEl = this.$el.querySelector(
        `[data-snapshot-index="${this.currentIndex}"]`
      );

      if (activeSnapshotItemDomEl) {
        this.$emit("scrollToActiveEl", activeSnapshotItemDomEl);
      }
    });
  }
}
